import {Injectable} from '@angular/core';
import {Service} from "../entities/service";
import {SharedService} from "./sharedService";
import {PagerDataObject} from "../entities/pagerDataObject";
import {catchError, map, tap} from 'rxjs/operators';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Currency} from "../entities/currency";
import { Observable, of } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable()
export class CurrencyService {

  constructor(private http: HttpClient, private sharedService: SharedService) {
  }

  getData(query: string): Observable<PagerDataObject> {
    if (query !== null)
    var currencies$ = this.http.get<PagerDataObject>(this.sharedService.apiUrl('api/currencies', query !== null?("/" + query):""))

    return currencies$;
  }

  add(currency: Currency): Observable<Currency> {
    return this.http.post<Currency>(this.sharedService.apiUrl('api/currencies/add'), currency, httpOptions).pipe(
      tap((currency: Currency) => this.log(`added currency w/ id=${currency.id}`)),
      catchError(this.handleError<Currency>('add'))
    );
  }

  getCurrency(id: string): Observable<Currency> {
    let currency$ = this.http.get<Currency>(this.sharedService.apiUrl('api/currencies/' + id))
    return currency$;
  }

  getConversionCodes(): Observable<{codes: string[], against: string[]}> {
    return this.http.get<{codes: string[], against: string[]}>(this.sharedService.apiUrl('api/currencies/conversion-codes')).pipe(
      catchError(this.handleError<{codes: string[], against: string[]}>('getConversionCodes', {codes: [], against: []}))
    );
  }

  delete(currency: Currency): Observable<Currency> {
    return this.http.post<Currency>(this.sharedService.apiUrl('api/currencies/delete'), currency, httpOptions).pipe(
      tap((currency: Currency) => this.sharedService.log(`deleted batch process w/ id=${currency.id}`)),
      catchError(this.sharedService.handleError<any>('deleteCurrency'))
    );
  }

  columns: Array<any> = [
    {key: 'view', style: {'flex': '0 0 100px', 'width': '1%'}, button: true},
    {name: 'Currency Name', tag: 'CURRENCY.NAME', key: 'name', filtering: true, sorting: true, sortingOrder: 'asc'},
    {name: 'Currency Code', tag: 'CURRENCY.CODE', key: 'code', filtering: true, sorting: true}
  ];

  getMetaInfo(): string[] {
    return ['name', 'code'];
  }

  getColumns(): string[] {
    return this.columns;
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  private log(message: string) {
    //this.messageService.add('HeroService: ' + message);
  }
}
